import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FormValidationStore } from './form-validation.store';

let _formIdSeq = 0;

/**
 * Dumb Formly renderer. Emits `(submitted)` with the model when the form
 * submits and is valid. The form exposes a stable `id` so external
 * submit buttons (e.g., the modal footer's Save) can target it via
 * `form="<id>"` — keeps the button outside the form's DOM subtree
 * without losing native submit semantics.
 */
@Component({
  selector: 'app-dynamic-form',
  standalone: true,
  imports: [ReactiveFormsModule, FormlyModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [FormValidationStore],
  template: `
    <form
      [id]="formId"
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      class="flex flex-col gap-4"
      autocomplete="off">
      <formly-form [form]="form" [fields]="fields()" [model]="model()"></formly-form>
    </form>
  `,
})
export class DynamicFormComponent<TModel = unknown> {
  private readonly validation = inject(FormValidationStore);

  readonly fields = input.required<FormlyFieldConfig[]>();
  readonly model = input<TModel>({} as TModel);
  readonly submitted = output<TModel>();

  readonly form = new FormGroup({});
  readonly formId = `mty-form-${++_formIdSeq}`;

  onSubmit(): void {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      this.validation.markAttempted();
      return;
    }
    this.validation.reset();
    this.submitted.emit(this.model());
  }
}
